<template>
  <div class="pageStyle">
    <div class="header">
      <div class="search">
        <div class="toExport" v-if="showToExport">
          <!-- <span><van-icon name="down" size="3.2vw" />导出数据</span> -->
          <img
            @click="toExport"
            src="https://static.xchengtech.cn/bf6d540cbfaa40a581b77f48d6c25bd1.png"
            alt=""
          />
        </div>
        <van-search
          @keyup.enter="onSearch"
          v-model="queryLabel"
          :placeholder="
            customerTypeValue == 'dkkh' ||
            customerTypeValue == 'czbt' ||
            customerTypeValue == 'xyxf'
              ? '请输入企业名称查询'
              : '请输入客户姓名查询'
          "
          shape="round"
          @search="onSearch"
        >
        </van-search>
      </div>
    </div>
    <div class="customerType">
      <span
        v-for="item in customerTypes"
        :class="customerTypeValue == item.value ? 'choice' : 'noChoice'"
        :key="item.value"
        @click="customerTypeChange(item.value)"
        >{{ item.label }}</span
      >
    </div>
    <div class="content">
      <!-- 贷款客户数据 -->
      <dkkhData ref="dkkh" v-if="customerTypeValue == 'dkkh'"></dkkhData>
      <!-- 信用修复数据 -->
      <xyxfData ref="xyxf" v-if="customerTypeValue == 'xyxf'"></xyxfData>
      <!-- 补贴信息数据 -->
      <czbtData ref="czbt" v-if="customerTypeValue == 'czbt'"></czbtData>
      <!-- 资产配置数据 -->
      <zcpzData ref="zcpz" v-if="customerTypeValue == 'zcpz'"></zcpzData>
      <!-- 账户管理数据 -->
      <zhglData ref="zhgl" v-if="customerTypeValue == 'zhgl'"></zhglData>
      <!-- 债务优化数据 -->
      <zwyhData ref="zwyh" v-if="customerTypeValue == 'zwyh'"></zwyhData>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Button,
  RadioGroup,
  Radio,
  Toast,
  Notify,
  Picker,
  Form,
  Empty,
  List,
  Field,
  Dialog,
  Collapse,
  CollapseItem,
  Popover,
} from "vant";
import dkkhData from "./module/dkkhData";
import czbtData from "./module/czbtData";
import zcpzData from "./module/zcpzData";
import zhglData from "./module/zhglData";
import zwyhData from "./module/zwyhData";
import xyxfData from "./module/xyxfData";
import { xcDepConfig } from "@/api/depConfig.js";
import { getDepNameByDomain } from "@/utils/index";
import { xcCustomerExport } from "@/api/xcCustomer";
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Popover);
Vue.use(Radio);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(List);
Vue.use(Form);
Vue.use(Collapse);
Vue.use(CollapseItem);
export default {
  components: {
    dkkhData,
    czbtData,
    zcpzData,
    zhglData,
    zwyhData,
    xyxfData,
  },
  created() {
    // 获取租户配置
    this.getDepConfig();
  },
  data() {
    return {
      customerTypes: [
        {
          label: "贷款客户",
          value: "dkkh",
        },
        {
          label: "信用修复",
          value: "xyxf",
        },
        {
          label: "补贴信息",
          value: "czbt",
        },
        {
          label: "资产配置",
          value: "zcpz",
        },
        {
          label: "账户管理",
          value: "zhgl",
        },
        {
          label: "债务优化",
          value: "zwyh",
        },
      ],
      customerTypeValue: "dkkh",
      queryLabel: "",
      depName: "",
      showToExport: false,
    };
  },
  methods: {
    onSearch() {
      console.log("queryLabel", this.queryLabel);
      // 贷款客户
      if (this.customerTypeValue == "dkkh") {
        this.$refs[this.customerTypeValue].query.companyNameLike =
          this.queryLabel;
      }
      // 补贴信息
      else if (this.customerTypeValue == "czbt") {
        this.$refs[this.customerTypeValue].query.companyName = this.queryLabel;
      }
      // 信用修复
      else if (this.customerTypeValue == "xyxf") {
        this.$refs[this.customerTypeValue].query.enterpriseName =
          this.queryLabel;
      }
      // 资产配置 账户管理 债务优化
      else {
        this.$refs[this.customerTypeValue].query.name = this.queryLabel;
      }
      this.$refs[this.customerTypeValue].onSearch();
    },
    // 选择客户类型
    customerTypeChange(value) {
      console.log("value", value);
      // 判断是否重复点击
      if (this.customerTypeValue != value) {
        this.customerTypeValue = value;
      }
    },
    getDepConfig() {
      this.depName = getDepNameByDomain();
      xcDepConfig(this.depName).then((res) => {
        if (res.exportCustomerData === true) {
          this.showToExport = true;
        }
      });
    },
    toExport() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      xcCustomerExport()
        .then((res) => {
          Toast.clear();
          window.location.href = res.url;
          console.log("res", res);
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
  },
};
</script>

<style scoped>
.pageStyle {
  min-height: 100%;
  background-image: url("https://static.xchengtech.cn/f2b454e00c904759853ee8e05f3e1841.png");
  background-repeat: no-repeat;
  background-color: #dce3ec;
  background-size: 100% auto;
  font-size: 3.6vw;
  /* padding-bottom: 17vw;
  padding-top: 52vw; */
  padding: 52vw 5vw 17vw 5vw;
}
.header {
  position: relative;
  padding: 5vw 0;
  padding-top: 0;
}
.header .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 6vw;
  position: relative;
  color: white;
}
.header .title div:nth-of-type(1) {
  font-size: 5vw;
  font-weight: 600;
}
.header .title div:nth-of-type(1) img {
  display: block;
  width: 4vw;
  position: absolute;
  /* bottom: 0; */
  left: 3vw;
}
.header .title div:nth-of-type(2) {
  font-size: 4vw;
  display: flex;
  align-items: center;
  gap: 1vw;
  color: white;
}
.header .title div:nth-of-type(2) img {
  display: block;
  width: 4vw;
}
.header .van-search {
  padding: 0;
  background-color: #dce3ec;
  overflow: hidden;
  border-radius: 12px;
}
.header .van-search .van-search__content {
  background-color: white;
  border-radius: 12px;
}
.header .van-search .van-cell {
  padding: 3vw 3vw 3vw 0;
}
.content {
  /* padding: 4vw; */
  margin: 0 0 4vw 0;
  /* background-color: #f7f8fa; */
  border-radius: 18px;
}

.companyName {
  position: relative;
}

.companyList {
  font-size: 14px;
  max-height: 60vw;
  overflow-y: auto;
  background-color: white;
  padding: 0 10px;
  position: absolute;
  top: 43px;
  width: 55vw;
  right: 16px;
  z-index: 99;
  border: 1px solid #ebedf0;
}

.companyList {
}

.companyList div {
  padding: 10px 0;
  display: block;
  width: 100%;
  border-bottom: 1px solid #ebedf0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.companyList div:nth-last-of-type(1) {
  border-bottom: none;
}
.toExport {
  position: absolute;
  top: -15.4vw;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: right;
  align-items: center;
  padding: 0 5vw;
}
.toExport span {
  padding: 1vw 2vw;
  background-color: #ffffff;
  border-radius: 4px;
  -webkit-box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  /* justify-content: right; */
  align-items: center;
  gap: 1vw;
}
.toExport img {
  display: block;
  width: 10vw;
}
/* 客户类型 */
.customerType {
  display: flex;
  width: 100%;
  gap: 2vw;
  overflow-x: auto;
  padding-bottom: 4vw;
  /* margin: 0 5vw; */
}
.customerType::-webkit-scrollbar {
  display: none;
}
.customerType span {
  border-radius: 35px;
  padding: 2vw 2vw;
  /* min-width: 22vw; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  font-size: 3.4vw;
  white-space: nowrap;
  border: 1px solid #eee;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}
.choice {
  background: #1487eb;
  font-weight: 500;
  color: white;
}
.noChoice {
  background: white;
  color: #667799;
  font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/view/myCustomer/index.vue